module.exports = __webpack_public_path__ + "img/Gif_web3.f2b9e390.gif";